import React, { Component } from 'react';
import { Popover, PopoverBody } from 'reactstrap';
import InputMask from 'react-input-mask';
import update from 'immutability-helper';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import Select from 'react-select';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import ErrorModal from '../../Components/ErrorModal/ErrorModal';




class LocationInfo extends Component {

    constructor(props) {
        super(props);

        this.handleInput = this.handleInput.bind(this);
        this.handleError = this.handleError.bind(this);
        this.buscaCEP = this.buscaCEP.bind(this);
        this.buscaMembro = this.buscaMembro.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);


        this.toggleSucessoCriacaoLocal = this.toggleSucessoCriacaoLocal.bind(this);
        this.verificaTipoLogradouro = this.verificaTipoLogradouro.bind(this);
        this.toggleModalAlertaTipoLogradouroDiferente = this.toggleModalAlertaTipoLogradouroDiferente.bind(this);
        this.prosseguirLogradouroSelecionado = this.prosseguirLogradouroSelecionado.bind(this);


        this.handleOnInput = this.handleOnInput.bind(this);
        this.habilitaSalvar = this.habilitaSalvar.bind(this);
        this.salvarAlteracoes = this.salvarAlteracoes.bind(this);
        this.apiLocalEntrega = this.apiLocalEntrega.bind(this);
        this.getTransportadoras = this.getTransportadoras.bind(this);

        this.state = {

            buscaMembro: {
                alertaBuscaResponsavel: false,
                alertaBuscaDestinatario: false
            },
            cepBusca: '',

            dadosGerais: this.props.dadosGerais ? this.props.dadosGerais : {
                nomeLocal: '',
                observacao: ''
            },
            idUsuarioDestinatario: '',
            idUsuarioResponsavel: '',
            // alertaBuscaMembro: false,
            buscaRealizada: false,
            nomeResp: this.props.dadosGerais ? this.props.dadosGerais.responsavel.nome : '',
            idUsuarioResp: this.props.dadosGerais ? this.props.dadosGerais.responsavel.idUsuario : '',
            codMembroBusca: this.props.dadosGerais ? this.props.dadosGerais.responsavel.codMembro : '',
            cpfDestinatario: this.props.dadosGerais ? this.props.dadosGerais.destinatario.cpf : '',
            exibeEndereco: this.props.exibeEndereco,
            tipoLogradouroSelecionado: null,
            isLoadingSalvarDados: false,
            novoLocal: this.props.match.params.idLocal === "novo",
            modalSucessoLocal: false,
            isOpenModalAlertaTipoLogradouroDiferente: false,
            transportadoraSelecionada: null,
            isLoadingLocalEntrega: false
        };



        this.tipoLogradouroOptions = [
            { label: "Rua", value: 1 },
            { label: "Avenida", value: 2 },
            { label: "Estrada", value: 3 },
            { label: "Travessa", value: 4 },
            { label: "Alameda", value: 5 },
            { label: "Praça", value: 6 },
            { label: "Vila", value: 7 },
            { label: "Largo", value: 8 },
            { label: "Secção", value: 9 },
            { label: "Rodovia", value: 10 },
            { label: "Quadra", value: 11 },
            { label: "Passagem", value: 12 },
            { label: "Chácara", value: 13 },
            { label: "Caminho", value: 14 },
            { label: "Beco", value: 15 },
            { label: "Caixa Postal", value: 16 },
            { label: "Aeroporto", value: 17 },
            { label: "Área", value: 18 },
            { label: "Campo", value: 19 },
            { label: "Colônia", value: 20 },
            { label: "Condomínio", value: 21 },
            { label: "Conjunto", value: 22 },
            { label: "Distrito", value: 23 },
            { label: "Esplanada", value: 24 },
            { label: "Estação", value: 25 },
            { label: "Favela", value: 26 },
            { label: "Fazenda", value: 27 },
            { label: "Feira", value: 28 },
            { label: "Jardim", value: 29 },
            { label: "Ladeira", value: 30 },
            { label: "Lago", value: 31 },
            { label: "Lagoa", value: 32 },
            { label: "Loteamento", value: 33 },
            { label: "Morro", value: 34 },
            { label: "Núcleo", value: 35 },
            { label: "Parque", value: 36 },
            { label: "Passarela", value: 37 },
            { label: "Pátio", value: 38 },
            { label: "Recanto", value: 39 },
            { label: "Residencial", value: 40 },
            { label: "Setor", value: 41 },
            { label: "Sítio", value: 42 },
            { label: "Trecho", value: 43 },
            { label: "Trevo", value: 44 },
            { label: "Vale", value: 45 },
            { label: "Vereda", value: 46 },
            { label: "Via", value: 47 },
            { label: "Viaduto", value: 48 },
            { label: "Outros", value: 49 },
        ]
        this.Configurations = new Configurations();
    }

    componentWillMount() {
        this.getTransportadoras();
    }


    getTransportadoras() {
        axios.get(this.Configurations.apiBasePath + `/logistica/transportadoras`).then(response => {
            const _transportadorasOptions = response.data.transportadoras.map(item => ({
                label: item.nome, value: item.idTransportadora
            }))
            this.setState({ transportadorasOptions: _transportadorasOptions }, () => {
                if (!this.state.novoLocal) {
                    this.apiLocalEntrega();
                }
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingTransportadoras: false }))
    }

    apiLocalEntrega() {
        this.setState({ isLoadingLocalEntrega: true })

        axios.get(this.Configurations.apiBasePath + `/logistica/locais-entrega/endereco/${this.props.match.params.idLocal}`).then(response => {
            const enderecoEntregaAux = { ...response.data.enderecoEntrega, cpfDestinatario: response.data.enderecoEntrega.cpf }
            this.setState({
                dadosGerais: enderecoEntregaAux,
                buscaRealizada: true,
                cepBusca: response.data.enderecoEntrega.cep,
                exibeEndereco: true,
                nomeLocal: response.data.enderecoEntrega.nomeLocal,
                responsavel: response.data.enderecoEntrega.responsavel,
                destinatario: response.data.enderecoEntrega.destinatario,
                tipoLogradouroSelecionado: response.data.enderecoEntrega.tipo ? this.tipoLogradouroOptions.filter(item => item.label.toLowerCase() === response.data.enderecoEntrega.tipo.toLowerCase())[0] : null,
                transportadoraSelecionada: this.state.transportadorasOptions.filter(item => item.value === response.data.enderecoEntrega.idTransportadora)[0],
                // dadosGerais: update(this.state.dadosGerais, { cpfResponsavel: { $set: response.data.enderecoEntrega.cpf } })
            })
        }).catch(this.handleError).finally(() =>
            this.setState({ isLoadingLocalEntrega: false }));
    }

    handleOnInput(e) {
        e.preventDefault();
        const _name = e.target.name
        this.setState({ dadosGerais: update(this.state.dadosGerais, { [_name]: { $set: e.target.value } }) }, () => {
            if (_name === "codMembroDestinatario" && this.state.dadosGerais.codMembroDestinatario === "") {
                this.setState({
                    dadosGerais: update(this.state.dadosGerais, { destinatario: { $set: "" } })
                })
            }
        })
    }

    buscaCEP() {
        this.setState({
            prosseguirLogradouro: false
        }, () => {
            axios.get(this.Configurations.apiBasePath + `/cep/${this.state.cepBusca}`).then(response => {
                const objeto1 = this.state.dadosGerais;
                const objeto2 = response.data.endereco;
                const novoObj = { ...objeto1, ...objeto2 }
                this.setState({
                    dadosGerais: novoObj,
                    exibeEndereco: true,
                    habilitaAlteracaoLogradouro: response.data.endereco.logradouro === '',
                    habilitaAlteracaoBairro: response.data.endereco.bairro === '',
                }, () => {
                    this.setState({ dadosGerais: update(this.state.dadosGerais, { numero: { $set: "" } }) })
                })
            }).catch(this.handleError).finally(() => this.setState())
        })
    }

    buscaMembro(e, type) {
        e.preventDefault();
        const _fieldType = type === 1 ? 'Responsavel' : 'Destinatario';

        let _state;

        if (!this.state.dadosGerais[`codMembro${_fieldType}`] || this.state.dadosGerais[`codMembro${_fieldType}`] === '') {
            _state = update(this.state.buscaMembro, { [`alertaBusca${_fieldType}`]: { $set: true } });
            this.setState({ buscaMembro: _state });
        } else {
            _state = update(this.state.buscaMembro, { [`alertaBusca${_fieldType}`]: { $set: false } });
            this.setState({ buscaMembro: _state });

            axios.get(this.Configurations.apiBasePath + `/membros/${this.state.dadosGerais[`codMembro${_fieldType}`]}`).then(response => {
                if (response.data.data.message) {
                    this.setState({ [`alertaBusca${_fieldType}`]: true })
                }
                else {
                    const _dadosMembro = {
                        nome: response.data.data.nome,
                        idUsuario: response.data.data.idUsuario,
                        codMembro: response.data.data.codMembro,
                        cpf: response.data.data.cpf
                    };
                    this.setState({
                        dadosGerais: update(this.state.dadosGerais, {
                            [`${_fieldType.toLowerCase()}`]: { $set: _dadosMembro.nome },
                            [`codMembro${_fieldType}`]: { $set: _dadosMembro.codMembro },
                            [`idUsuario${_fieldType}`]: { $set: _dadosMembro.idUsuario },
                            [`cpf${_fieldType}`]: { $set: _dadosMembro.cpf }
                        }),
                        buscaRealizada: true,
                        [`alertaBusca${_fieldType}`]: false
                    })
                }
            }).catch(this.handleError).finally(() => this.setState({ isLoadingBuscaMembro: false }));
        }
    }

    handleInput(e) {
        e.preventDefault();
        const _name = e.target.name
        this.setState({ [_name]: e.target.value })
    }

    habilitaSalvar() {
        const E = this.state.exibeEndereco,
            L = this.state.dadosGerais.nomeLocal.trim() !== '',
            N = this.state.dadosGerais.numero ? this.state.dadosGerais.numero.trim() !== '' : false,
            LO = this.state.tipoLogradouroSelecionado !== null,
            B = this.state.buscaRealizada,
            EN = this.state.dadosGerais.logradouro ? this.state.dadosGerais.logradouro.trim() !== '' : false,
            BA = this.state.dadosGerais.bairro ? this.state.dadosGerais.bairro.trim() !== '' : false,
            // A = this.state.alertaBuscaMembro,
            T = this.state.transportadoraSelecionada !== null;
        return !(E * L * N * LO * B * EN * BA * T);
    }

    salvarAlteracoes() {
        if (this.verificaTipoLogradouro() || this.state.prosseguirLogradouro) {
            this.setState({ isLoadingSalvarDados: true })
            const _salvarDados = {
                idUsuarioResponsavel: this.state.dadosGerais.idUsuarioResponsavel,
                idUsuarioDestinatario: !!this.state.dadosGerais.idUsuarioDestinatario ? this.state.dadosGerais.idUsuarioDestinatario : null,
                nomeLocal: this.state.dadosGerais.nomeLocal,
                idTransportadora: this.state.transportadoraSelecionada.value,
                endereco: {
                    cep: this.state.dadosGerais.cep,
                    tipoLogradouro: this.state.tipoLogradouroSelecionado.label,
                    logradouro: this.state.dadosGerais.logradouro,
                    numero: this.state.dadosGerais.numero,
                    bairro: this.state.dadosGerais.bairro,
                    cidade: this.state.dadosGerais.cidade,
                    uf: this.state.dadosGerais.uf,
                    observacao: this.state.dadosGerais.obs,
                    complemento: this.state.dadosGerais.complemento,
                }
            }
            if (this.state.novoLocal) {
                axios.post(this.Configurations.apiBasePath + `/logistica/locais-entrega/novo`, _salvarDados).then(response => {
                    this.setState({
                        idNovoLocal: response.data.idNovoLocal,
                        modalSucessoLocal: true
                    })
                }).catch(this.handleError).finally(() => this.setState({ isLoadingSalvarDados: false }))
            } else {
                axios.put(this.Configurations.apiBasePath + `/logistica/locais-entrega/atualiza/${this.props.match.params.idLocal}`, _salvarDados).then(response => {
                    this.setState({
                        modalSucessoLocal: true
                    })
                    this.apiLocalEntrega();
                }).catch(this.handleError).finally(this.setState({ isLoadingSalvarDados: false }))
            }
        } else {
            this.setState({
                isOpenModalAlertaTipoLogradouroDiferente: true
            })
        }
    }

    handleChange(newValue, actionMeta) {
        const name = actionMeta.name;
        let _valor;
        switch (actionMeta.action) {
            case "clear": _valor = null; break;
            case "select-option": _valor = { value: newValue.value, label: newValue.label }; break;
            case "create-option": _valor = { label: newValue.label }; break;
            default: _valor = null; break;
        }
        this.setState({ [name]: _valor === null ? null : _valor })
    }

    toggleSucessoCriacaoLocal(idLocal) {
        this.setState({ modalSucessoLocal: !this.state.modalSucessoLocal }, () => {
            if (!this.state.modalSucessoLocal && this.state.novoLocal) this.props.history.push(`/logistica/locais-entrega/detalhes/${idLocal}`)
        })
    }

    prosseguirLogradouroSelecionado() {
        this.setState({
            prosseguirLogradouro: true,
        }, () => {
            this.toggleModalAlertaTipoLogradouroDiferente();
            this.salvarAlteracoes();
        })
    }

    toggleModalAlertaTipoLogradouroDiferente() {
        this.setState({
            isOpenModalAlertaTipoLogradouroDiferente: !this.state.isOpenModalAlertaTipoLogradouroDiferente,
        })
    }
    verificaTipoLogradouro() {
        const tipoLogradouroApi = this.state.dadosGerais.logradouro.split(" ")[0];
        const tipoLogradouroSelect = this.state.tipoLogradouroSelecionado.label;

        return tipoLogradouroApi === tipoLogradouroSelect;
    }

    handleError(err) {
        this.setState({
            hasError: true, errorMessage: (err.response && err.response.data && !!err.response.data.message) ?
                err.response.data.message : 'Erro inesperado.'
        })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }


    render() {
        return (
            <div className="row new-location logistics">
                <div className="col-10">
                    <h2 className="title-1">{this.state.novoLocal ? 'Novo' : 'Editar'} local de entrega</h2>
                </div>
                <div className='col-2 text-right'>
                    <button className='btn btn-outline-secondary' onClick={() => this.props.history.push('/logistica/locais-entrega')}>Voltar</button>
                </div>
                {/* {JSON.stringfy(!!this.state.dadosGerais && this.state.dadosGerais)} */}
                <div className='col-12'>
                    {(this.state.isLoadingLocalEntrega && !this.state.novoLocal) ? (
                        <div className="row no-gutters">
                            <div className="col-12 text-center">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        </div>
                    ) : (
                        <div className='row'>
                            <div className='col-12'>
                                <div className="row no-gutters px-3 py-3 border rounded">
                                    <div className="col-5 pt-2 pb-3 px-3">
                                        <small>{`* informações obrigatórias`}</small>
                                    </div>
                                    {!this.state.novoLocal && (
                                        <div className='col-3 text-right'>
                                            < button className='btn btn-outline-info' disabled={this.state.novoLocal} onClick={() => this.props.history.push(`/logistica/locais-entrega/detalhes/${this.props.match.params.idLocal}/assinantes`)}>ver assinantes</button>
                                        </div>
                                    )}
                                    {!this.state.novoLocal && (
                                        <div className='col-4 text-right'>
                                            < button className='btn btn-outline-info' disabled={this.state.novoLocal} onClick={() => this.props.history.push(`/logistica/locais-entrega/detalhes/${this.props.match.params.idLocal}/organizacoes`)}>ver organizações cadastradas</button>
                                        </div>
                                    )}
                                    <div className="col-12 py-2">
                                        <div className="row align-items-top">
                                            <div className="col-6">
                                                <form onSubmit={() => { }}>
                                                    <div className="form-group">
                                                        <label>Responsável *</label><br />
                                                        <InputMask
                                                            autoComplete="off"
                                                            name="codMembroResponsavel"
                                                            type="number"
                                                            className="form-control m-0 cod-membro"
                                                            placeholder="Cód. de membro"
                                                            value={this.state.dadosGerais.codMembroResponsavel}
                                                            onChange={this.handleOnInput}
                                                            onBlur={(e) => { this.buscaMembro(e, 1) }}
                                                        />
                                                        <div className='row no-gutters'>
                                                            <div className='col-12'>
                                                                {this.state.alertaBuscaResponsavel && (
                                                                    <span className="text-danger"><i>Por favor insira um código de membro válido.</i></span>
                                                                )}
                                                                {(!this.state.alertaBuscaResponsavel && this.state.buscaRealizada) && (
                                                                    <div className="d-flex nome-responsavel p-2 mt-2">{this.state.dadosGerais.responsavel}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>

                                            <div className="col-6">
                                                <form onSubmit={() => { }}>
                                                    <div className="form-group">
                                                        <label>Destinatário</label><br />
                                                        <InputMask
                                                            autoComplete="off"
                                                            name="codMembroDestinatario"
                                                            type="number"
                                                            className="form-control m-0 cod-membro"
                                                            placeholder="Cód. de membro"
                                                            value={this.state.dadosGerais.codMembroDestinatario}
                                                            onChange={this.handleOnInput}
                                                            onBlur={(e) => { this.buscaMembro(e, 2) }}
                                                        />
                                                        <div className='row no-gutters'>
                                                            <div className='col-12'>
                                                                {this.state.alertaBuscaDestinatario && !!this.state.dadosGerais.codMembroDestinatario && (
                                                                    <span className="text-danger"><i>Por favor insira um código de membro válido.</i></span>
                                                                )}
                                                                {(!this.state.alertaBuscaDestinatario && this.state.buscaRealizada) && !!this.state.dadosGerais.codMembroDestinatario && (
                                                                    <div className="d-flex nome-destinatario p-2 mt-2">{this.state.dadosGerais.destinatario}
                                                                    </div>
                                                                )}
                                                                {this.state.buscaRealizada && !this.state.alertaBuscaDestinatario && (
                                                                    <div className='row px-2'>
                                                                        <div className='col-12'>
                                                                            CPF: {this.state.dadosGerais.cpfDestinatario}
                                                                        </div>
                                                                    </div>

                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div >
                                    <div className="col-6 py-2">
                                        <label>Nome do local *</label>
                                        <input name="nomeLocal" className="form-control" onChange={this.handleOnInput} value={this.state.dadosGerais.nomeLocal} />
                                    </div>
                                    <div className="offset-1 col-5 py-2">
                                        <label>CEP *</label>
                                        <div className="row align-items-center">
                                            <div className="col-7">
                                                <InputMask
                                                    autoComplete="off"
                                                    name="cepBusca"
                                                    type="tel"
                                                    className="form-control m-0"
                                                    maskChar=""
                                                    id="cep"
                                                    mask="99999-999"
                                                    placeholder="00000-000"
                                                    value={!!this.state.cepBusca ? this.state.cepBusca.substr(0, 9) : ''}
                                                    onChange={this.handleInput}
                                                />
                                            </div>
                                            <div className="col-5 text-left">
                                                <button onClick={this.buscaCEP} className="btn btn-outline-info">buscar CEP</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-4 py-4'>
                                        <div className='form-group'>
                                            <label htmlFor="transportadora">Transportadora *</label>
                                            {this.state.exibeEndereco && (
                                                <Select
                                                    id="transportadora"
                                                    placeholder="Selecione uma transportadora"
                                                    closeMenuOnSelect={true}
                                                    options={this.state.transportadorasOptions}
                                                    onChange={this.handleChange}
                                                    name="transportadoraSelecionada"
                                                    defaultValue={this.state.transportadoraSelecionada ? this.state.transportadorasOptions.filter(item => item.value === this.state.transportadoraSelecionada.value) : null}
                                                    isClearable
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-12 py-2">
                                        {this.state.exibeEndereco && (
                                            <div className="row my-3">
                                                <div className="col-12 py-3">
                                                    <div className="row">
                                                        <div className="col-4">
                                                            <label>Cidade</label>
                                                            <div className="row">
                                                                <div className="col-12 informacoes-endereco">
                                                                    {this.state.dadosGerais.cidade}, {this.state.dadosGerais.uf}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-4" id="PopBairro">
                                                            <label>Bairro *</label>
                                                            {this.state.habilitaAlteracaoBairro ? (
                                                                < input onChange={(e) => this.handleOnInput(e)} type="text" name="bairro" id={1} maxLength="50" className="form-control" value={this.state.dadosGerais.bairro} />
                                                            ) : (
                                                                <div className='row'>
                                                                    <div className="col-12 informacoes-endereco">
                                                                        {this.state.dadosGerais.bairro}
                                                                    </div>
                                                                </div>

                                                            )}
                                                        </div>
                                                        <div className="col-4">
                                                            <div className='form-group'>
                                                                <label htmlFor="tipoLogradouro">Tipo de logradouro *</label>
                                                                <Select
                                                                    id="tipoLogradouro"
                                                                    placeholder="Selecione uma opção"
                                                                    closeMenuOnSelect={true}
                                                                    options={this.tipoLogradouroOptions}
                                                                    onChange={this.handleChange}
                                                                    name="tipoLogradouroSelecionado"
                                                                    defaultValue={this.state.tipoLogradouroSelecionado ? this.tipoLogradouroOptions && this.tipoLogradouroOptions.filter(item => item.value === this.state.tipoLogradouroSelecionado.value) : null}
                                                                    isClearable
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="row py-2 align-items-center">
                                                        <div className="col-6">
                                                            <label htmlFor="endereco">Endereço *</label>
                                                            {this.state.habilitaAlteracaoLogradouro ? (
                                                                <input onChange={(e) => this.handleOnInput(e)} type="text" name="logradouro" id={1} maxLength="50" className="form-control" value={this.state.dadosGerais.logradouro} />
                                                            ) : (
                                                                <div className="row">
                                                                    <div className="col-12 informacoes-endereco">
                                                                        {this.state.dadosGerais.logradouro}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="col-2" id="PopNumero">
                                                            <label htmlFor="numero">Número*</label>
                                                            <input onChange={(e) => this.handleOnInput(e)} type="text" name="numero" id={1} maxLength="7" className="form-control" value={this.state.dadosGerais.numero} />
                                                        </div>
                                                        <Popover className={`popover-pendente`} placement="bottom" isOpen={this.props.popoverNumero} target="PopNumero" toggle={this.props.togglePopoverNumero}>
                                                            <PopoverBody className="text-center">Por favor, preencha o número.</PopoverBody>
                                                        </Popover>
                                                        <div className="col-4">
                                                            <label htmlFor="complemento">Complemento</label>
                                                            <input onChange={(e) => this.handleOnInput(e)} name="complemento" id={2} type="text" className="form-control" value={this.state.dadosGerais.complemento} />
                                                        </div>
                                                        <div className="col-12 py-3">
                                                            <div className="form-group m-0">
                                                                <label htmlFor="motivo">Observação:</label>
                                                                <textarea onChange={this.handleOnInput} id="obs" type="text" className="form-control input-mensagem" name="obs" value={this.state.dadosGerais.obs} />
                                                            </div>
                                                        </div>
                                                        <Popover className={`popover-pendente`} placement="bottom" isOpen={this.props.popoverBairro} target="PopBairro" toggle={this.props.togglePopoverBairro}>
                                                            <PopoverBody className="text-center">Por favor, preencha o bairro.</PopoverBody>
                                                        </Popover>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {this.state.isLoadingSalvarDados ? (
                                        <div className="col-12 text-center">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    ) : (
                                        <div className="col-12 text-center">
                                            <button disabled={this.state.isLoadingLocalEntrega || this.habilitaSalvar()} onClick={this.salvarAlteracoes} className="btn btn-outline-success">salvar</button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>



                <Modal isOpen={this.state.modalSucessoLocal} toggle={() => this.toggleSucessoCriacaoLocal(this.state.idNovoLocal)}>
                    <ModalHeader toggle={() => this.toggleSucessoCriacaoLocal(this.state.idNovoLocal)}>
                        {this.state.novoLocal ? 'Novo local de entrega' : 'Edição de local de entrega'}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.novoLocal ? 'Novo local criado com sucesso! :)' : 'Alterações realizadas com sucesso! :)'}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={() => this.toggleSucessoCriacaoLocal(this.state.idNovoLocal)}>ok</Button>
                    </ModalFooter>
                </Modal>

                {!!this.state.tipoLogradouroSelecionado && !!this.state.dadosGerais && !!this.state.dadosGerais.logradouro && (
                    <Modal isOpen={this.state.isOpenModalAlertaTipoLogradouroDiferente} toggle={this.toggleModalAlertaTipoLogradouroDiferente}>
                        <ModalHeader toggle={this.toggleModalAlertaTipoLogradouroDiferente}>Aviso</ModalHeader>
                        <ModalBody>
                            O tipo de logradouro selecionado ({this.state.tipoLogradouroSelecionado.label}) é diferente do que encontrado na busca do cep ({this.state.dadosGerais.logradouro.split(" ")[0]}). Deseja prosseguir com <strong>{this.state.tipoLogradouroSelecionado.label} ?</strong>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="success" onClick={this.prosseguirLogradouroSelecionado}>Prosseguir</Button>
                            <Button color="secondary" onClick={this.toggleModalAlertaTipoLogradouroDiferente}>Cancelar</Button>
                        </ModalFooter>
                    </Modal>
                )}

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    goBack={!this.state.hasError}
                />

            </div >
        )
    }
}

export default LocationInfo;